// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__3X4kF","title":"AfterImages90_title__1zRbq","images":"AfterImages90_images__2R4RN"};